module.exports = __webpack_public_path__ + "static/media/undp-horizontal.2165864f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undp-horizontal.png
// module id = 997
// module chunks = 0